<template>
  <div class="auth">
      <header class="auth__header header">
          <div class="header__container container-fluid">
              <div class="header__hlogo hlogo">
                  <img src="/images/logo-white-rus.svg">
              </div>
              <div class="lang-switcher-wrapper dropdown">
                  <a href="#" class="nav-link dropdown-toggle hlang-toggle" role="button" data-bs-toggle="dropdown"
                      aria-expanded="false">
                      <div class="lang">
                          <svg viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M9.47051 1.09375C5.61113 1.09375 2.31582 3.5875 1.09863 7.03125H17.9018C16.6549 3.5875 13.3596 1.09375 9.47051 1.09375Z"
                                  fill="#F9F9F9" />
                              <path
                                  d="M9.47051 18.9062C13.3596 18.9062 16.6549 16.4125 17.8721 12.9688H1.09863C2.31582 16.4422 5.61113 18.9062 9.47051 18.9062Z"
                                  fill="#ED4C5C" />
                              <path
                                  d="M1.09844 7.03125C0.771875 7.95156 0.59375 8.96094 0.59375 10C0.59375 11.0391 0.771875 12.0484 1.09844 12.9688H17.9016C18.2281 12.0484 18.4062 11.0391 18.4062 10C18.4062 8.96094 18.2281 7.95156 17.9016 7.03125H1.09844Z"
                                  fill="#428BC1" />
                          </svg>
                          <span>RU</span>
                      </div>
                  </a>
                  <ul class="dropdown-menu hlang-dropdown-menu">
                      <li>
                          <a class="hlang-dropdown-menu__item dropdown-item" href="#">
                              <div class="lang">
                                  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M22.0002 60.3V46.5L11.7002 54.1C14.6002 56.8 18.1002 58.9 22.0002 60.3M42.0002 60.3C45.9002 58.9 49.4002 56.8 52.3002 54.1L42.0002 46.4V60.3M3.7002 42C4.0002 43 4.4002 43.9 4.9002 44.9L8.8002 42H3.7002ZM55.2002 42L59.1002 44.9C59.5002 44 59.9002 43 60.3002 42H55.2002Z"
                                          fill="#2A5F9E" />
                                      <path
                                          d="M23.5001 38H2.6001C2.9001 39.4 3.3001 40.7 3.7001 42H8.8001L4.9001 44.9C5.7001 46.6 6.6001 48.1 7.7001 49.6L18.0001 42H22.0001V44L10.3001 52.6L11.7001 54L22.0001 46.5V60.3C23.3001 60.8 24.6001 61.1 26.0001 61.4V38H23.5001ZM61.4001 38H38.0001V61.4C39.4001 61.1 40.7001 60.7 42.0001 60.3V46.5L52.3001 54C53.7001 52.7 54.9001 51.3 56.1001 49.8L45.4001 42H52.2001L58.3001 46.5C58.6001 46 58.9001 45.4 59.1001 44.9L55.2001 42H60.3001C60.7001 40.7 61.1001 39.4 61.4001 38"
                                          fill="white" />
                                      <path
                                          d="M7.7002 49.6C8.5002 50.7 9.3002 51.7 10.2002 52.7L22.0002 44.1V42.1H18.0002L7.7002 49.6ZM45.5002 42L56.2002 49.8C56.6002 49.3 56.9002 48.8 57.3002 48.3C57.4002 48.2 57.4002 48.1 57.5002 48.1C57.8002 47.6 58.2002 47 58.5002 46.5L52.2002 42H45.5002Z"
                                          fill="#ED4C5C" />
                                      <path
                                          d="M42.0002 3.7002V17.5002L52.3002 9.9002C49.4002 7.2002 45.9002 5.1002 42.0002 3.7002ZM22.0002 3.7002C18.1002 5.1002 14.6002 7.2002 11.7002 9.9002L22.0002 17.6002V3.7002ZM60.3002 22.0002C60.0002 21.0002 59.6002 20.1002 59.1002 19.1002L55.2002 22.0002H60.3002M8.8002 22.0002L4.9002 19.1002C4.5002 20.1002 4.1002 21.0002 3.7002 22.0002H8.8002Z"
                                          fill="#2A5F9E" />
                                      <path
                                          d="M40.5001 26.0001H61.3001C61.0001 24.6001 60.6001 23.3001 60.2001 22.0001H55.1001L59.0001 19.1001C58.2001 17.4001 57.3001 15.9001 56.2001 14.4001L46.0001 22.0001H42.0001V20.0001L53.7001 11.4001L52.3001 10.0001L42.0001 17.5001V3.7001C40.7001 3.2001 39.4001 2.9001 38.0001 2.6001V26.0001H40.5001ZM2.6001 26.0001H26.0001V2.6001C24.6001 2.9001 23.3001 3.3001 22.0001 3.7001V17.5001L11.7001 10.0001C10.3001 11.3001 9.1001 12.7001 7.9001 14.2001L18.6001 22.0001H11.8001L5.7001 17.5001C5.4001 18.0001 5.1001 18.6001 4.9001 19.1001L8.8001 22.0001H3.7001C3.3001 23.3001 2.9001 24.6001 2.6001 26.0001Z"
                                          fill="white" />
                                      <path
                                          d="M56.3001 14.3998C55.5001 13.2998 54.7001 12.2998 53.8001 11.2998L42.0001 19.8998V21.8998H46.0001L56.3001 14.3998M18.5001 21.9998L7.9001 14.1998C7.5001 14.6998 7.2001 15.1998 6.8001 15.6998C6.7001 15.7998 6.7001 15.8998 6.6001 15.8998C6.3001 16.3998 5.9001 16.9998 5.6001 17.4998L11.7001 21.9998H18.5001Z"
                                          fill="#ED4C5C" />
                                      <path
                                          d="M61.4 26H38V2.6C36.1 2.2 34.1 2 32 2C29.9 2 27.9 2.2 26 2.6V26H2.6C2.2 27.9 2 29.9 2 32C2 34.1 2.2 36.1 2.6 38H26V61.4C27.9 61.8 29.9 62 32 62C34.1 62 36.1 61.8 38 61.4V38H61.4C61.8 36.1 62 34.1 62 32C62 29.9 61.8 27.9 61.4 26Z"
                                          fill="#ED4C5C" />
                                  </svg>
                                  <span>EN</span>
                              </div>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
      </header>

      <div class="auth-page__form auth-form text-center">
          <div class="auth-form__wrap">
              <div class="auth-form__title mb-3">DS Indoor Services</div>
              <div class="auth-form__caption">Сброс пароля</div>
              <div class="auth-form__form-group form-outline ">
                  <input type="email" id="form2Example2" placeholder="Электронная почта" class="form-control form-control-lg" v-model="email" />
              </div>

              <button type="button" class="auth-form__enter btn btn-primary" v-on:click="send()">
                  <span>Продолжить</span>
              </button>
          </div>
      </div>
  </div>
  <Alert />
</template>

<script>
import Alert from '../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
  name: 'ForgotPasswordComponent',
  components: { Alert },
  props: {
      route_password_reset: String,
  },
  data() {
      return {
          email: '',
      }
  },
  methods: {
      ...mapMutations('alerts', ['addAlert']),
      send: async function () {
          if (this.email == '') {
            this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите электронную почту!' })
            return;
          }

          const response = await axios.post(this.route_password_reset, {
              'email': this.email
          }).then((response) => {
              return response.data
          });

          if (response.status == 'ok') {
            this.addAlert({ type: 'success', title: 'Успех', text: response.message })
            window.location.href = '/';
          } else if (response.status == 'error') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: response.message })
          }
      },
  }
}
</script>

<style scoped>

</style>
